import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";

import { axiosApiInstance } from "../pages/api/axios";
import Drawer from "./Drawer";

const DynamicForm = dynamic(() => import("./DynamicForm"));

export default function EditPopOverForm(props) {
  const { title, open, setOpen, Trigger } = props;

  return (
    <React.Fragment>
      {Trigger && <Trigger onClick={() => setOpen(true)} />}

      <Drawer isOpen={open} onClose={() => setOpen(false)} title={title}>
        <FormContent {...props} />
      </Drawer>
    </React.Fragment>
  );
}

const FormContent = ({ url, onSuccess, setOpen }) => {
  const [formFields, setFormFields] = useState();

  useEffect(() => {
    fetchFrom();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

  function fetchFrom() {
    axiosApiInstance.get(url).then((response) => {
      setFormFields(
        response.data.data.form_fields.filter(({ read_only }) => !read_only)
      );
    });
  }

  return (
    <Drawer.Content className="p-8 pb-0">
      {formFields && (
        <DynamicForm
          fields={formFields}
          submitURL={url}
          onSuccess={(name) => {
            setOpen(false);
            onSuccess(name);
          }}
          onCancel={() => setOpen(false)}
          editForm
        />
      )}
    </Drawer.Content>
  );
};
